import React, { ChangeEvent, Component } from "react";
import Modal from "react-modal";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetTakeOffCsvDTO from "../../../models/DTO/IGetTakeOffCsvDTO";
import IGetTakeOffOrderDTO from "../../../models/DTO/IGetTakeOffOrderDTO";
import IOnGetTakeOffCsvDTO from "../../../models/DTO/IOnGetTakeOffCsvDTO";
import IOnGetTakeOffOrderDTO from "../../../models/DTO/IOnGetTakeOffOrderDTO";
import IOnProcessTakeOffOrderItemDTO from "../../../models/DTO/IOnProcessTakeOffOrderItemDTO";
import IOnTypeaheadCatalogItemDTO from "../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import IProcessTakeOffOrderItemDTO from "../../../models/DTO/IProcessTakeOffOrderItemDTO";
import ITypeaheadCatalogItemDTO from "../../../models/DTO/ITypeaheadCatalogItemDTO";
import IUpdateOrderEntryItemDTO from "../../../models/DTO/IUpdateOrderEntryItemDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ICatalog_Item from "../../../models/ICatalog_Item";
import ICategory from "../../../models/ICategory";
import INotification from "../../../models/INotification";
import IOrder from "../../../models/IOrder";
import IOrder_Item from "../../../models/IOrder_Item";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import IOwTableCols from "../../../models/IOwTableCols";
import ISupplierModel from "../../../models/ISupplierModel";
import ITake_Off_Items_Category_Map from "../../../models/ITake_Off_Items_Category_Map";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import UIService from "../../../services/UIService";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import Typeahead from "../../shared/Typeahead/Typeahead";
import TakeOffConvertToOrderSidebar from "../TakeOffConvertToOrderSidebar/TakeOffConvertToOrderSidebar";
import TakeOffOrderCategorySidebar from "../TakeOffOrderCategorySidebar/TakeOffOrderCategorySidebar";
import * as _ from "lodash-es";
import TakeOffUploadModal from "./TakeOffUploadModal/TakeOffUploadModal";
import { Socket } from "socket.io-client";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";

type Props = {
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    match: any;
};

type State = {
    crumbs: IBreadcrumbs[];
    takeOff: IOrder;
    clearTypeahead: boolean;
    typeaheadCatalogItems: ICatalog_Item[];
    columns: IOwTableCols[];
    isDataFetching: boolean;
    initialData: boolean;
    takeOffItems: IOrder_ItemUI[];
    takeOffItemCategoryMaps: ITake_Off_Items_Category_Map[];
    originalTakeOffItemCategoryMaps?: ITake_Off_Items_Category_Map[];
    takeOffCategories: ICategory[];
    attributes: string[];
    selectedCatalogItem?: ICatalog_Item | null;
    sourceElem: string | null;
    sourceElemRow?: IOrder_Item;
    categoryCountArr: { category_id: number; category_name: string; qty: number }[];
    takeOffCategoryCountArr: { category_id: number; category_name: string; category: ICategory; qty: number }[];
    modalIsOpen: boolean;
    modalComponent: any;
};

class TakeOffDetail extends Component<Props, State> {
    overlayRef: any = null;

    constructor(props: any) {
        super(props);

        const columns: IOwTableCols[] = this.getStandardColumns();

        this.state = {
            crumbs: [
                {
                    title: "dashboard",
                    url: "/dashboard",
                },
                {
                    title: "take_offs",
                    url: "/take_offs",
                },
            ],
            clearTypeahead: false,
            isDataFetching: false,
            initialData: true,
            columns,
            takeOff: {} as IOrder,
            takeOffItems: [],
            takeOffCategories: [],
            takeOffItemCategoryMaps: [],
            attributes: [],
            typeaheadCatalogItems: [],
            sourceElem: null,
            sourceElemRow: undefined,
            categoryCountArr: [],
            takeOffCategoryCountArr: [],
            modalIsOpen: false,
            modalComponent: null,
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.TakeOffOnGetTakeOffOrder, this.onGetTakeOff);
        this.props.socket.on(EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, this.onTypeaheadCatalogItem);
        this.props.socket.on(EndpointsEnum.TakeOffOnProcessTakeOffOrderItem, this.onProcessTakeOffOrderItem);
        this.props.socket.on(EndpointsEnum.TakeOffOnGetTakeOffCsv, this.onGetTakeOffCsv);

        this.getTakeOff();
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.TakeOffOnGetTakeOffOrder, this.onGetTakeOff);
        this.props.socket.removeListener(EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, this.onTypeaheadCatalogItem);
        this.props.socket.removeListener(EndpointsEnum.TakeOffOnProcessTakeOffOrderItem, this.onProcessTakeOffOrderItem);
        this.props.socket.removeListener(EndpointsEnum.TakeOffOnGetTakeOffCsv, this.onGetTakeOffCsv);
    }

    getStandardColumns = (): IOwTableCols[] => {
        const columns: IOwTableCols[] = [
            {
                title: "",
                valueProp: "",
                isActionsCol: true,
                renderFn: this.renderActionsCol,
                renderFnEmitsRow: true,
            },
            {
                title: "name",
                valueProp: "Catalog_Item",
                valueSubProp: "name",
            },
            {
                title: "sku",
                valueProp: "Catalog_Item",
                valueSubProp: "sku",
            },
        ];

        if (this.props.supplierModel.has_dimensions) {
            columns.push({
                title: "",
                valueProp: "",
                titleRenderFn: this.renderDimensionsTitle,
                renderFnEmitsRow: true,
                renderFn: this.renderDimensions,
                className: "w-20r text-center",
            });
        }

        // columns.push({
        //     title: "",
        //     valueProp: "",
        //     titleRenderFn: this.renderAttributesTitle,
        //     renderFnEmitsRow: true,
        //     renderFn: this.renderAttributes,
        //     className: "text-center",
        // });

        return columns;
    };

    handleCategoryQtyChange = (e: ChangeEvent<any>, row: IOrder_ItemUI, type: ITake_Off_Items_Category_Map) => {
        const itemMaps: ITake_Off_Items_Category_Map[] = this.state.takeOffItemCategoryMaps;

        for (const itemMap of itemMaps) {
            if (Number(itemMap.id) === Number(type.id)) {
                itemMap.qty = e.target.value;
            }
        }

        this.setState({
            takeOffItemCategoryMaps: itemMaps,
        });
    };

    renderTypeCol = (row: IOrder_ItemUI, type: ITake_Off_Items_Category_Map[], category: ICategory) => {
        let typeMap: ITake_Off_Items_Category_Map = {} as ITake_Off_Items_Category_Map;

        for (const typeMapItem of type) {
            if (typeMapItem.order_item_id === row.id && typeMapItem.category_id === category.id) {
                typeMap = typeMapItem;
            }
        }

        if (row.rowEditMode) {
            console.log("typeMap", typeMap);
            return (
                <div>
                    <OwInputWrapper
                        name={"qty"}
                        fn={(e: ChangeEvent<any>) => {
                            this.handleCategoryQtyChange(e, row, typeMap);
                        }}
                        value={typeMap.qty}
                    />
                </div>
            );
        } else {
            return <div>{typeMap.qty}</div>;
        }
    };

    getTakeOff = () => {
        // console.error("Need to setup this.props.match.params.guid here");

        const payload: IGetTakeOffOrderDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            takeOffOrderGuid: "",
            takeOffOrderGuid: this.props.match.params.guid,
        };

        this.props.socket.emit(EndpointsEnum.TakeOffGetTakeOffOrder, payload);

        this.setState({ isDataFetching: true });
    };

    onGetTakeOff = (data: IOnGetTakeOffOrderDTO) => {
        const columns = this.getStandardColumns();

        for (const type of data.takeOffCategories) {
            if (!type.has_dependents) {
                columns.push({
                    skipTitleTranslate: true,
                    title: type.name,
                    valueProp: "",
                    renderFn: (row: any) => {
                        return this.renderTypeCol(row, data.takeOffItemCategoryMaps, type);
                    },
                    renderFnEmitsRow: true,
                });
            }
        }

        // TODO
        // let attributes = [];
        //
        // for (let item of data.takeOffOrder.Order_Items) {
        //     if (item.Catalog_Item && item.Catalog_Item.attributes) {
        //         const itemAttr = Object.keys(item.Catalog_Item.attributes);
        //
        //         for (let attr of itemAttr) {
        //             let found = false;
        //
        //             for (let existingAttr of attributes) {
        //                 if (existingAttr === attr) {
        //                     found = true;
        //                 }
        //             }
        //
        //             if (!found) {
        //                 attributes.push(attr);
        //             }
        //         }
        //     }
        // }
        const takeOffCategoryCountArr: { category_id: number; category_name: string; category: ICategory; qty: number }[] = [];

        for (const takeOffCat of data.takeOffCategories) {
            takeOffCategoryCountArr.push({
                category_id: takeOffCat.id,
                category_name: takeOffCat.name,
                category: takeOffCat,
                qty: 0,
            });
        }

        for (const takeOffItemMap of data.takeOffItemCategoryMaps) {
            for (const takeOffCatItem of takeOffCategoryCountArr) {
                if (takeOffItemMap.category_id === takeOffCatItem.category_id) {
                    takeOffCatItem.qty += takeOffItemMap.qty;
                }
            }
        }

        let categoryCountArr: { category_id: number; category_name: string; qty: number }[] = [];

        for (const orderItem of data.takeOffOrder.Order_Items) {
            if (orderItem.Catalog_Item?.Category) {
                let found = false;

                for (const catArrItem of categoryCountArr) {
                    if (catArrItem.category_id === orderItem.Catalog_Item.category_id) {
                        found = true;
                        catArrItem.qty += Number(orderItem.qty);
                    }
                }

                if (!found) {
                    if (orderItem.Catalog_Item.Category) {
                        categoryCountArr.push({
                            category_id: orderItem.Catalog_Item.category_id!,
                            category_name: orderItem.Catalog_Item.Category.name,
                            qty: Number(orderItem.qty),
                        });
                    }
                }
            }
        }

        for (const itemCategoryMap of data.takeOffItemCategoryMaps) {
            for (const catAccountArrItem of categoryCountArr) {
                if (Number(itemCategoryMap.Catalog_Item?.category_id) === Number(catAccountArrItem.category_id)) {
                    catAccountArrItem.qty += itemCategoryMap.qty;
                }
            }
        }

        categoryCountArr = _.orderBy(categoryCountArr, ["category_name"], ["asc"]);

        const state: any = {
            columns,
            // attributes,
            takeOff: data.takeOffOrder,
            takeOffItems: data.takeOffOrder.Order_Items,
            takeOffCategories: data.takeOffCategories,
            takeOffItemCategoryMaps: data.takeOffItemCategoryMaps,
            isDataFetching: false,
            initialData: false,
            categoryCountArr,
            takeOffCategoryCountArr,
        };

        if (this.state.crumbs.length === 2) {
            const crumbs = this.state.crumbs;

            crumbs.push({
                title: data.takeOffOrder.Project?.name + ` - Take Off #${data.takeOffOrder.name}` || "",
                url: "",
                skipTranslate: true,
            });

            state.crumbs = crumbs;
        }

        document.title = `Orderwerks >> ${data.takeOffOrder.Project?.name} - Take Off #${data.takeOffOrder.name}`;

        this.setState(state);
    };

    getTakeOffCsv = () => {
        const payload: IGetTakeOffCsvDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            takeOffOrderGuid: this.state.takeOff.guid,
        };

        this.props.socket.emit(EndpointsEnum.TakeOffGetTakeOffCsv, payload);
    };

    onGetTakeOffCsv = (data: IOnGetTakeOffCsvDTO) => {
        const blob = new Blob([data.csvData], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        link.download = data.filename;
        link.click();
    };

    openCsvUploadModal = () => {
        const modalComponent = (
            <TakeOffUploadModal
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                takeOffOrder={this.state.takeOff}
                takeOffItemCategory={this.state.takeOffCategories}
            />
        );

        this.setState({
            modalIsOpen: true,
            modalComponent,
        });
    };

    closeModal = () => {
        this.setState(
            {
                modalIsOpen: false,
                modalComponent: null,
            },
            () => {
                this.getTakeOff();
            }
        );
    };

    toggleEditMode = (row: IOrder_ItemUI, index: number, cancel?: boolean) => {
        const takeOffItems = this.state.takeOffItems;

        let performSave = false;
        let enableEditMode = false;

        for (const item of takeOffItems) {
            if (item.id === row.id) {
                if (!cancel) {
                    performSave = item.rowEditMode;
                }
                item.rowEditMode = !item.rowEditMode;
                enableEditMode = item.rowEditMode;
            }
        }

        const state: any = {
            takeOffItems,
        };

        // if (enableEditMode) {
        //     state.originalTakeOffItemCategoryMaps = {
        //         ...this.state.takeOffItemCategoryMaps
        //     };
        // }
        //
        // if (!enableEditMode && cancel) {
        //     state.takeOffItemCategoryMaps = this.state.originalTakeOffItemCategoryMaps;
        // }

        this.setState(state, () => {
            if (performSave && !cancel) {
                this.saveTakeOffRow(row);
            }
        });
    };

    saveTakeOffRow = (row: IOrder_ItemUI) => {
        const itemCatalogMaps: ITake_Off_Items_Category_Map[] = [];

        for (const itemMap of this.state.takeOffItemCategoryMaps) {
            if (itemMap.order_item_id === row.id) {
                itemCatalogMaps.push(itemMap);
            }
        }

        const updateItemPayload: Partial<IUpdateOrderEntryItemDTO> = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            orderEntryItemGuid: row.guid,
            orderGuid: this.state.takeOff.guid,
        };

        if (row.width) {
            updateItemPayload.width = row.width;
        }

        if (row.height) {
            updateItemPayload.height = row.height;
        }

        if (row.depth) {
            updateItemPayload.depth = row.depth;
        }

        this.props.socket.emit(EndpointsEnum.OrderEntryUpdateOrderEntryItem, updateItemPayload);

        if (itemCatalogMaps.length) {
            const payload: IProcessTakeOffOrderItemDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                takeOffOrderGuid: this.state.takeOff.guid,
                orderItemCatalogMap: itemCatalogMaps,
            };

            this.props.socket.emit(EndpointsEnum.TakeOffProcessTakeOffOrderItem, payload);
        }
    };

    confirmDelete = (row: IOrder_ItemUI, index: number) => {
        const sourceElem = `row-${index}`;

        this.setState({
            sourceElem,
            sourceElemRow: row,
        });
    };

    renderActionsCol = (row: IOrder_ItemUI, index: number) => {
        if (row.rowEditMode) {
            return (
                <div>
                    {/*<i className={"fad fa-times pointer text-danger me-4"} onClick={() => { this.toggleEditMode(row, index, true) }}/>*/}
                    <i
                        className={"fad fa-check pointer text-success"}
                        onClick={() => {
                            this.toggleEditMode(row, index);
                        }}
                    />
                </div>
            );
        } else {
            return (
                <div>
                    <i
                        className={"fad fa-trash-alt pointer text-danger me-4"}
                        onClick={() => {
                            this.confirmDelete(row, index);
                        }}
                    />
                    <i
                        className={"fad fa-pencil pointer text-primary"}
                        onClick={() => {
                            this.toggleEditMode(row, index);
                        }}
                    />
                </div>
            );
        }
    };

    renderAttributesTitle = (col: IOwTableCols) => {
        return (
            <div>
                <OwLabel title={"attributes"} />
                <div className={"d-flex justify-content-center align-items-center"}>
                    {this.state.attributes.map((attr, index) => {
                        return <div key={index}>{attr}</div>;
                    })}
                </div>
            </div>
        );
    };

    renderAttributes = (row: any) => {
        const catalogItem = row.Catalog_Item;

        if (catalogItem && catalogItem.attributes) {
            return (
                <div>
                    <div>
                        {this.state.attributes.map((attr, index) => {
                            return <div key={index}>{catalogItem.attributes[attr]}</div>;
                        })}
                    </div>
                </div>
            );
        } else {
            return <div></div>;
        }
    };

    renderDimensionsTitle = (col: IOwTableCols) => {
        return (
            <div className={"text-center w-12r"}>
                <OwLabel title={"dimensions"} />
                <div>
                    <span>
                        <OwLabel title={"W"} noBottomMargin={true} className={"w-4r"} />
                    </span>
                    <span>
                        <OwLabel title={"H"} noBottomMargin={true} className={"w-4r"} />
                    </span>
                    <span>
                        <OwLabel title={this.props.supplierModel.length_for_depth ? "L" : "D"} noBottomMargin={true} className={"w-4r"} />
                    </span>
                </div>
            </div>
        );
    };

    handleDimensionChange = (e: ChangeEvent<any>, dim: "width" | "height" | "depth", row: IOrder_ItemUI, index: number) => {
        const orderItems = this.state.takeOffItems;

        for (const item of orderItems) {
            if (item.id === row.id) {
                item[dim] = e.target.value;
            }
        }

        this.setState({
            takeOffItems: orderItems,
        });
    };

    renderDimensions = (row: IOrder_ItemUI, index: number) => {
        const width = row.width || row.Catalog_Item!.width;
        const height = row.height || row.Catalog_Item!.height;
        const depth = row.depth || row.Catalog_Item!.depth;

        if (row.rowEditMode) {
            return (
                <div className={"d-flex text-center"}>
                    <div className={"w-4r"}>
                        <OwInputWrapper
                            name={"width"}
                            type={"number"}
                            value={width}
                            fn={(e: ChangeEvent<any>) => {
                                this.handleDimensionChange(e, "width", row, index);
                            }}
                        />
                    </div>
                    <div className={"w-4r"}>
                        <OwInputWrapper
                            name={"height"}
                            type={"number"}
                            value={height}
                            fn={(e: ChangeEvent<any>) => {
                                this.handleDimensionChange(e, "height", row, index);
                            }}
                        />
                    </div>
                    <div className={"w-4r"}>
                        <OwInputWrapper
                            name={"depth"}
                            type={"number"}
                            value={depth}
                            fn={(e: ChangeEvent<any>) => {
                                this.handleDimensionChange(e, "depth", row, index);
                            }}
                        />
                    </div>
                </div>
            );
        } else {
            return (
                <div className={"d-flex text-center"}>
                    <div className={"w-4r"}>{width}</div>
                    <div className={"w-4r"}>{height}</div>
                    <div className={"w-4r"}>{depth}</div>
                </div>
            );
        }
    };

    openCategoryViewer = () => {
        const component = (
            <TakeOffOrderCategorySidebar
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                notifyFn={this.props.notifyFn}
                setActivityIndicator={this.props.setActivityIndicator}
                socket={this.props.socket}
                cancelFn={this.closeSidebar}
                takeOffOrder={this.state.takeOff}
                takeOffCategories={this.state.takeOffCategories || []}
            />
        );

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    closeSidebar = () => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);

        this.getTakeOff();
    };

    performItemLookup = (name: string) => {
        if (!this.state.takeOff?.Catalog) {
            return null;
        }

        const payload: ITypeaheadCatalogItemDTO = {
            excludeComponents: true,
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
            catalogGuid: this.state.takeOff.Catalog.guid,
            options: {
                searchName: true,
                searchDescription: true,
                searchSku: true,
                searchUpc: true,
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);
    };

    onTypeaheadCatalogItem = (data: IOnTypeaheadCatalogItemDTO) => {
        this.setState({
            typeaheadCatalogItems: data.catalog_items,
        });
    };

    clearTypeahead = () => {
        this.setState({
            clearTypeahead: false,
        });
    };

    selectCatalogItem = (data: ICatalog_Item) => {
        this.setState({
            selectedCatalogItem: data,
        });
    };

    addSelectedItem = () => {
        if (this.state.selectedCatalogItem) {
            let existingItem = false;

            for (const item of this.state.takeOffItems) {
                if (item.Catalog_Item?.id === this.state.selectedCatalogItem.id) {
                    existingItem = true;
                }
            }

            if (!existingItem) {
                const payload: IProcessTakeOffOrderItemDTO = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel.guid,
                    takeOffOrderGuid: this.state.takeOff.guid,
                    catalogItemGuid: this.state.selectedCatalogItem.guid,
                };

                this.props.socket.emit(EndpointsEnum.TakeOffProcessTakeOffOrderItem, payload);
            } else {
                const notification: INotification = {
                    message: "unable_to_add_duplicate_item",
                    position: NotificationPositionEnum.bc,
                    level: NotificationLevelEnum.error,
                };

                this.props.notifyFn(null, notification);
            }
        }
    };

    onProcessTakeOffOrderItem = (data: IOnProcessTakeOffOrderItemDTO) => {
        this.getTakeOff();

        this.setState({
            selectedCatalogItem: null,
            clearTypeahead: true,
        });
    };

    cancelDeleteOverlay = () => {
        this.setState({
            sourceElem: null,
            sourceElemRow: undefined,
        });
    };

    commitDeleteOverlay = () => {
        if (this.state.sourceElemRow) {
            const payload: IProcessTakeOffOrderItemDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                takeOffOrderGuid: this.state.takeOff.guid,
                deleteFlag: true,
                orderItemGuid: this.state.sourceElemRow.guid,
            };

            this.props.socket.emit(EndpointsEnum.TakeOffProcessTakeOffOrderItem, payload);

            this.setState({
                sourceElem: null,
                sourceElemRow: undefined,
            });
        }
    };

    getTakeOffQty = (catCountMap: { category_id: number; category_name: string; category: ICategory; qty: number }) => {
        let takeoff_qty = 0;

        if (catCountMap.category.has_dependents) {
            for (const mapItem of this.state.takeOffCategoryCountArr) {
                if (mapItem.category.parent_category_id === catCountMap.category.id) {
                    takeoff_qty += Number(mapItem.category.takeoff_qty);
                }
            }

            return takeoff_qty;
        } else {
            const takeoff_qty = Number(catCountMap.category.takeoff_qty || 0);

            return takeoff_qty;
        }
    };

    getItemQty = (catCountMap: { category_id: number; category_name: string; category: ICategory; qty: number }) => {
        let qty = 0;

        if (catCountMap.category.has_dependents) {
            for (const mapItem of this.state.takeOffCategoryCountArr) {
                if (mapItem.category.parent_category_id === catCountMap.category.id) {
                    qty += Number(mapItem.qty);
                }
            }

            return qty;
        } else {
            const qty = Number(catCountMap.qty || 0);

            return qty;
        }
    };

    getTotalItems = (catCountMap: { category_id: number; category_name: string; category: ICategory; qty: number }) => {
        if (catCountMap.category.has_dependents) {
            let totalSum = 0;

            for (const mapItem of this.state.takeOffCategoryCountArr) {
                if (mapItem.category.parent_category_id === catCountMap.category.id) {
                    const qty = this.getItemQty(mapItem);
                    const takeoff_qty = this.getTakeOffQty(mapItem);

                    totalSum += qty * takeoff_qty;
                }
            }

            return totalSum;
        } else {
            const qty = this.getItemQty(catCountMap);
            const takeoff_qty = this.getTakeOffQty(catCountMap);

            return qty * takeoff_qty;
        }
    };

    cancelSidebar = () => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);
    };

    openConvertToOrder = () => {
        const sidebar = (
            <TakeOffConvertToOrderSidebar
                supplierModel={this.props.supplierModel}
                cancelFn={this.cancelSidebar}
                notifyFn={this.props.notifyFn}
                setActivityIndicator={this.props.setActivityIndicator}
                userModel={this.props.userModel}
                socket={this.props.socket}
                types={this.state.takeOffCategories}
                orderGuid={this.state.takeOff.guid}
            />
        );

        this.props.setSidebarComponent(sidebar);
        this.props.toggleSidebar(true);
    };

    render() {
        return (
            <div className="TakeOffDetail">
                <Breadcrumbs crumbs={this.state.crumbs} />

                <div className="row mt-4">
                    <div className="col-12 d-flex align-items-center justify-content-between">
                        <OwTitle title={"take_off"} leftIconName={"fad fa-table"} className={"me-2"} />

                        <OwButton leftIconClass={"fad fa-retweet-alt"} title={"convert_to_order"} fn={this.openConvertToOrder} />
                    </div>
                </div>

                {/*<div className={"row"}>*/}
                {/*    <div className={"col-12"}>*/}
                {/*        <div className={""}>*/}
                {/*            <div className={"card card-body card-dark bg-dark text-white"}>Details Section / File*/}
                {/*                Uploads*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className={"row mt-4 mb-2"}>
                    <div className={"col"}>
                        <div>
                            <OwButton
                                className={"btn-warning"}
                                fn={this.openCategoryViewer}
                                title={"type_viewer"}
                                leftIconClass={"fas fa-sitemap"}
                            />
                        </div>
                    </div>

                    <div className={"ms-auto"}>
                        <div className={"col"}>
                            <OwButton title={"download_csv"} leftIconClass={"fad fa-download"} fn={this.getTakeOffCsv} />
                            <OwButton
                                title={"upload_csv"}
                                leftIconClass={"fad fa-upload"}
                                fn={this.openCsvUploadModal}
                                className={"btn-danger ms-2"}
                            />
                        </div>
                    </div>
                </div>

                <div className={"row mb-2"}>
                    <div className={"col-12 col-md-3 col-lg-2"}>
                        <Typeahead
                            isSelectableFn={() => {
                                return true;
                            }}
                            typeaheadApiFn={this.performItemLookup}
                            titleProp={"name"}
                            selectedItem={this.state.selectedCatalogItem}
                            selectedItemFn={this.selectCatalogItem}
                            typeaheadItems={this.state.typeaheadCatalogItems}
                            className={"me-2"}
                            clearTypeaheadCallback={this.clearTypeahead}
                            clearTypeahead={this.state.clearTypeahead}
                        />
                    </div>
                    <div>
                        <OwButton title={"add"} leftIconClass={"fas fa-plus"} fn={this.addSelectedItem} />
                    </div>
                </div>

                <div className={"table-responsive position-relative"}>
                    <ConfirmDeleteOverlayFn
                        targetElem={this.state.sourceElem}
                        handleConfirm={this.commitDeleteOverlay}
                        handleCancel={this.cancelDeleteOverlay}
                        nestedParentElem={"take-off-detail-table"}
                        skipMainView={true}
                    />

                    <OwTable
                        id={"take-off-detail-table"}
                        columns={this.state.columns}
                        dataSet={this.state.takeOffItems}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.isDataFetching}
                        initialData={this.state.initialData}
                        tableConfig={{ tableStriped: true }}
                    />
                </div>

                <div className={"row mb-3"}>
                    <div className={"col-4 ms-auto"}>
                        <table className={"table " + (UIService.isMainViewLight() ? "" : "table-dark")}>
                            <tr>
                                <th>
                                    <OwLabel title={"type"} />
                                </th>
                                <th className={"text-end"}>
                                    <OwLabel title={"type_qty"} />
                                </th>
                                <th className={"text-end"}>
                                    <OwLabel title={"no_items"} />
                                </th>
                                <th className={"text-end"}>
                                    <OwLabel title={"total_items"} />
                                </th>
                            </tr>
                            {this.state.takeOffCategoryCountArr.map((catCountMap) => {
                                return (
                                    <tr key={catCountMap.category_id}>
                                        <td>
                                            <b className={catCountMap.category.parent_category_id ? "ms-4" : ""}>
                                                {catCountMap.category_name}
                                            </b>
                                        </td>
                                        <td className={"text-end"}>{this.getTakeOffQty(catCountMap)}</td>
                                        <td className={"text-end"}>{this.getItemQty(catCountMap)}</td>
                                        <td className={"text-end"}>{this.getTotalItems(catCountMap)}</td>
                                    </tr>
                                );
                            })}
                        </table>
                    </div>
                </div>

                <div className={"row mb-3"}>
                    <div className={"col-4 ms-auto"}>
                        <table className={"table " + (UIService.isMainViewLight() ? "" : "table-dark")}>
                            <tr>
                                <th>
                                    <OwLabel title={"category"} noBottomMargin={true} />
                                </th>
                                <th>
                                    <OwLabel title={"no_items"} noBottomMargin={true} />
                                </th>
                            </tr>

                            {this.state.categoryCountArr.map((catCountMap) => {
                                return (
                                    <tr key={catCountMap.category_id}>
                                        <td>
                                            <b>{catCountMap.category_name}</b>
                                        </td>
                                        <td>{catCountMap.qty}</td>
                                    </tr>
                                );
                            })}
                        </table>
                    </div>
                </div>

                <div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        contentLabel="Orderwerks"
                        shouldCloseOnOverlayClick={false}
                        className={"modalContentClass"}
                        overlayClassName={"modalOverlayClass"}>
                        {this.state.modalComponent}
                    </Modal>
                </div>
            </div>
        );
    }
}

export default TakeOffDetail;
